import React, { useState, useEffect} from 'react'
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DashAuthWrapper from './../components/DashAuthWrapper'
import {  fetchServicesStart } from './../redux/VendorServices/vendor.actions';
import { fetchApptsStart, updateApptStart } from '../redux/Appointments/appts.actions';
import Button from './../components/forms/Button';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const mapState = ({ apptsData, vendorsData }) => ({
	appts: apptsData.appts,
  	services: vendorsData.services
	
})

const VendorEditApptDetails = props => {
	const { appts, services } = useSelector(mapState);
	const dispatch = useDispatch();
	const { documentID } = useParams();
	const history = useHistory();
	
	
	const { apptData } = appts;
	const { serviceData } = services;

	useEffect(() => {
		dispatch(
			fetchServicesStart()
		);
		dispatch(
			fetchApptsStart()
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []);


	//filter appt by documentID
	const custAppt = [];
	if(Array.isArray(apptData)){
		for(let i = 0; i < apptData.length; i++){
			if(apptData[i].documentID === `${documentID}`){
				custAppt.push(apptData[i]);
			}
		}
	}
	
	const [productName, setProductName] = useState(custAppt[0].productName)
	const [startDate, setStartDate] = useState(custAppt[0].startDate.toDate());
	const [apptDetails, setApptDetails] = useState(`${custAppt[0].apptDetails}`);
	
	const [custsID] = useState(custAppt[0].custsID);
	const [custName] = useState(custAppt[0].custName);
	const [vendorsID] = useState(custAppt[0].vendorsID);
	const [vendorsName] = useState(custAppt[0].vendorsName);
	const [vendorsPhone] = useState(custAppt[0].vendorsPhone);
	const [custAddress] = useState(custAppt[0].custAddress);

	const handleSubmit = e => {
		e.preventDefault();
	
		dispatch(
			updateApptStart({
				documentID,
				startDate,
				productName,
				custsID,
				custName,
				vendorsID,
				vendorsName,
				custAddress,
				vendorsPhone,
				apptDetails
			})
		);
		alert('Update Successfull!')
		history.goBack()
		
	
	};
	
	const congfigAuthWrapper = {
		headline: `Edit Appointment for ${custName}`
	}
	
	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
			<h4>Select service, date, and add details. Then click "EDIT" to update appointment.</h4>
			<div className="pb-5 mt-5 d-flex flex-column justify-content-center">
				<form className=" mx-auto">
					<div className="row mb-5">
						<div className="col-xs-12 col-6 pt-1 pb-1 ">
							<select name="services"  className="p-1" value={productName} onChange={e => setProductName(e.target.value)}>
								{(Array.isArray(serviceData) && serviceData.length > 0) && serviceData.map((products, index) => {
								const {
									productName
								} = products;
								
								return (
								<option key={index} value={productName} name={productName}>{productName}</option>
									
								)
								
								})}
								
							</select>
						</div>
						<div className="col-xs-12 col-6 pt-1 pb-1 ">
							<DatePicker className="p-1" selected={startDate} onChange={date => setStartDate(date)} />
						</div>
					</div>
					<div className="pb-1">
						<label htmlFor="Description" className="text-dark">Details</label><br></br>
						<textarea value={apptDetails} id="Description" name="Description" rows="2" cols="45" onChange={e => setApptDetails(e.target.value)}></textarea>
					</div>
					
						
					
				</form>
				<div className="col-sm-12 col-lg-12 pt-1 pb-1">
					<Button type="submit" onClick={handleSubmit}>
						EDIT
					</Button>
					
					<Button className="btn cancel mx-3" onClick={() => history.goBack()}>
						CANCEL
					</Button>
					
				</div>
			</div>
		</DashAuthWrapper>


		
	)
}

export default VendorEditApptDetails;